const pages = [
  { number: '00', name: 'HOME', url: '/' },
  { number: '01', name: 'DESTINATION', url: '/destinations' },
  { number: '02', name: 'CREW', url: '/crew' },
  { number: '03', name: 'TECHNOLOGY', url: '/technology' }
]

export default pages
